// localStorage key for the persisted store (the `persist` middleware's `name`). CGTrader
// has no SPA shell - every navigation is a full-page load - so persisting lets generation
// status survive navigation and propagate across tabs (see index.js).
export const STORAGE_KEY = 'cgt:generationStatus'

// The single resolved status a consumer (sidebar today, top nav later) renders.
export const GENERATION_STATUS = {
  IDLE: 'idle',
  GENERATING: 'generating',
  ENHANCING: 'enhancing',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
}

// Ceiling for the unviewed finished-run list persisted to localStorage: enough
// for a full concurrency-cap batch plus a couple of stragglers, small enough
// that an abandoned browser profile never accumulates an unbounded payload.
export const MAX_GENERATION_RESULTS = 5

export const DEFAULT_GENERATION_STATUS = {
  // Live status of the in-flight runs. The scalar fields mirror the most recently
  // started run; activeRunCount carries how many are in flight (paid tiers can run
  // several concurrently) and drives the count inside the nav spinner.
  isGenerating: false,
  isEnhancing: false,
  enhancingSessionId: undefined,
  runId: undefined,
  sessionId: undefined,
  generationStartedAt: null,
  activeRunCount: 0,
  // Owner of the persisted status: the id (normalized to a string, see resolveViewerId)
  // of the user who started the run. localStorage is shared by every user of a browser,
  // so the site-wide nav gates on this to avoid surfacing one user's run to a later
  // anon/other account (see GenerationStatus/actions).
  userId: null,
  // Outcome of the most recently finished run (generated or failed). Shape:
  // { status: 'succeeded'|'failed', runId, sessionId, providerModelId, isEnhancement,
  //   finishedAt, ...(success: slug, title, previewUrl, pathname)
  //              ...(failure: failureReason, failureMessage, providerErrorCode) }
  lastResult: null,
  // Every finished run the user has not opened/dismissed yet, newest first, capped
  // at MAX_GENERATION_RESULTS (same shape as lastResult, which always equals
  // lastResults[0]). Drives the stacked result rows in the Create with AI dropdown.
  lastResults: [],
  // runId of the last finished run whose "model ready" toast the user explicitly closed
  // (X button). Persisted like the rest of the store, so an explicit close never reappears
  // across reloads or tabs. Auto-dismiss is deliberately not recorded here - it stays
  // per-page and may re-show on refresh until the user closes it.
  dismissedRunId: null,
}
